import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M11.6663 15.6484V15.6381C11.6612 15.6415 11.656 15.645 11.6508 15.6484H11.6663Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M8.33301 3.14844C10.8127 3.14844 13.0113 4.35182 14.3767 6.20644C14.7314 6.6882 14.3512 7.3151 13.753 7.3151C13.4841 7.3151 13.2358 7.17855 13.0707 6.96633C11.9728 5.55579 10.2589 4.64844 8.33301 4.64844C5.0193 4.64844 2.33301 7.33473 2.33301 10.6484C2.33301 13.9621 5.0193 16.6484 8.33301 16.6484C8.77481 16.6484 9.16634 16.9927 9.16634 17.4345C9.16634 17.8115 8.88262 18.138 8.50574 18.1465C8.44832 18.1478 8.39074 18.1484 8.33301 18.1484C4.19087 18.1484 0.833008 14.7906 0.833008 10.6484C0.833008 6.5063 4.19087 3.14844 8.33301 3.14844Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M9.37176 11.6979C9.60353 11.4613 9.88931 11.2484 10.2205 11.2484C10.7474 11.2484 11.1437 11.7426 10.8719 12.1939C10.347 13.0655 9.3916 13.6484 8.30005 13.6484C6.64319 13.6484 5.30005 12.3053 5.30005 10.6484C5.30005 8.99158 6.64319 7.64844 8.30005 7.64844C9.3916 7.64844 10.347 8.2314 10.8719 9.10297C11.1437 9.5543 10.7474 10.0484 10.2205 10.0484C9.88931 10.0484 9.60353 9.83559 9.37176 9.59894C9.09949 9.32094 8.71991 9.14844 8.30005 9.14844C7.47162 9.14844 6.80005 9.82001 6.80005 10.6484C6.80005 11.4769 7.47162 12.1484 8.30005 12.1484C8.71991 12.1484 9.09949 11.9759 9.37176 11.6979Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M15.5995 18.1484C15.5995 18.1484 12.6826 16.6484 12.6826 13.6484C12.6826 11.7734 13.9326 10.6484 15.5991 10.6484C17.2656 10.6484 18.516 11.7734 18.516 13.6484C18.516 16.3986 15.5995 18.1484 15.5995 18.1484Z",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("ellipse", {
  cx: "15.599",
  cy: "13.5638",
  rx: "0.833333",
  ry: "0.833333",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}